<script>
export default {}
</script>
<template>
	<footer class="footer">
		<div class="container-fluid"></div>
	</footer>
</template>